import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, message } from 'antd';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './components/auth/LoginPage';
import RegisterPage from './components/auth/RegisterPage';
import Dashboard from './pages/Dashboard';
import Accounts from './pages/Accounts';
import ProtectedRoute from './components/common/ProtectedRoute';
import 'antd/dist/reset.css';
import './App.css';
import Sessions from './pages/Sessions';
import Users from './pages/Users';

const antdTheme = {
  token: {
    colorPrimary: '#1f2937',
    borderRadius: 16,
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
};

const AppRoutes = () => {
  const { user, loading } = useAuth();

  message.config({
    top: 24,
    duration: 4,
    maxCount: 3,
  });

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route 
          path="/login" 
          element={user ? <Navigate to="/dashboard" /> : <LoginPage />} 
        />
        <Route 
          path="/register" 
          element={user ? <Navigate to="/dashboard" /> : <RegisterPage />} 
        />
        
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/accounts" element={
          <ProtectedRoute>
            <Accounts />
          </ProtectedRoute>
        } />
        <Route path="/sessions" element={
  <ProtectedRoute>
    <Sessions />
  </ProtectedRoute>
} />
<Route path="/users" element={
  <ProtectedRoute>
    <Users />
  </ProtectedRoute>
} />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Router>
  );
};

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <AuthProvider>
        <div className="App">
          <AppRoutes />
        </div>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;